import { render, staticRenderFns } from "./GStudentImportPreCheck.vue?vue&type=template&id=60c6a6cd&scoped=true&"
import script from "./GStudentImportPreCheck.vue?vue&type=script&lang=ts&"
export * from "./GStudentImportPreCheck.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentImportPreCheck.vue?vue&type=style&index=0&id=60c6a6cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c6a6cd",
  null
  
)

export default component.exports